import { Table } from '@shared/components'
import React, { useMemo } from 'react'

import { PotentialBookingSummaryColumns, transformedPotentialBookingSummary } from './SupervisorDashboard.data'

export const PotentialBookingSummary = (props: any) => {
  const data = useMemo(() => {
    return props.data ? transformedPotentialBookingSummary(props.data) : []
  }, [props])

  const columns = useMemo(() => {
    return PotentialBookingSummaryColumns
  }, [])

  return (
    <>
      <Table columns={columns as any} data={data} />
    </>
  )
}
